export default __webpack_public_path__ + "static/media/plus.336af02f.svg";